/** @file Resolves an attachment's image record; a dangling image id is NOT_FOUND at the attachment. */
import { throwError } from '@pose2d/format/throwError';
import type { AttachmentDoc, Doc, ImageDoc } from '@pose2d/format/types';

/** `doc.images[att.image]`, or NOT_FOUND `{ kind: 'image' }` at `attachments.<id>.image`. */
export function requireAttachmentImage(doc: Doc, id: string, att: AttachmentDoc): ImageDoc {
  const image = doc.images[att.image];
  if (image === undefined) throwError('NOT_FOUND', { kind: 'image', ref: att.image }, { path: `attachments.${id}.image` });
  return image;
}
